import { render, staticRenderFns } from "./ModifySectionTemplates.vue?vue&type=template&id=702a0fba"
import script from "./ModifySectionTemplates.vue?vue&type=script&lang=js"
export * from "./ModifySectionTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports